import { Container, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { withFirebase } from "../Firebase";
import CourseCard from "../Formation/CourseCard";

const FormationMenu = (props) => {
  const [courses, setcourses] = useState([]);

  return (
    <Container>
      <Grid
        container
        justify="center"
        alignItems="center"
        spacing={4}
        style={{
          minHeight: "70vh",
          marginTop: 32,
        }}
      >
        {courses.map((course, key) => (
          <Grid key={key} item container justify="center" xs={12} lg={4}>
            <CourseCard courseId={course.id} size={40} imageUrl={course.image} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default withFirebase(FormationMenu);
